import { inject, Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, ValidationErrors } from "@angular/forms";
import { HemoTechLicenseService } from 'app/services/license/hemo-tech/hemo-tech-license.service';
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable({ providedIn: 'root' })

export class HemotechLicenseValidator implements AsyncValidator {

  private service: HemoTechLicenseService = inject(HemoTechLicenseService);

  validate(
    control: AbstractControl
  ): Observable< ValidationErrors | null > {
    return this.service.checkIfLicenseExists(control.value).pipe(
      map(valid => (
        !valid ? { invalidLicense: true} : null
        )),
      catchError(() => of(null))
    )
  }
}
